import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function TimePopup({ time, type, onClose }) {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSelect = () => {
    // сохраняем выбор, если надо
    localStorage.setItem("selectedTime", time);
    setLoading(true);

    setTimeout(() => {
      setLoading(false);
      navigate("/booking"); // переход на новую страницу
    }, 2000);
  };

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center px-4">
      <div className="bg-[#F1F1F1] max-w-2xl w-full rounded-xl overflow-hidden shadow-xl relative">
        {loading ? (
          <div className="flex flex-col items-center justify-center p-12">
            <img src="/loader.svg" alt="Loading..." className="w-16 h-16" />
            <p className="mt-4 text-sm text-neutral-600">Processing...</p>
          </div>
        ) : (
          <>
            <div
              className="h-48 bg-cover bg-center"
              style={{ backgroundImage: "url('/bg.png')" }}
            ></div>

            <div className="flex items-center justify-between px-6 py-4 border-neutral-300 border-b-2">
              <div>
                <div className="text-md font-base">{time}</div>
                <div className="text-sm text-neutral-800">{type}</div>
              </div>
              <button
                className="border px-12 py-2 rounded-md text-sm bg-white border-neutral-300 hover:bg-gray-100"
                onClick={handleSelect}
              >
                Select
              </button>
            </div>

            <div className="p-4 text-sm text-neutral-500 leading-relaxed">
              Nammos is inspired by the Mediterranean Sea & Sun. Nammos culinary
              creations is the zeal and devotion to great food paired with the most
              electric ambiance...
            </div>
          </>
        )}
      </div>
    </div>
  );
}
